import React from 'react';
import { withStyles } from '@material-ui/styles';

// import cx from 'clsx';
import _get from 'lodash/get';
// import _set from 'lodash/set';

const styles = theme => ({
    caption: {
        width: '24px',
        height: '24px',
        borderRadius: '100%',
        background: '#fc821f',
        fontSize: '13px',
        lineHeight: '24px',
        color: '#ffffff',
        fontWeight: 'bold',
        textAlign: 'center',
    },
});

const AfitdBadgeCount = props => {
    const classes = _get(props, 'classes');
    const count = _get(props, 'count');

    return count ? <figcaption className={classes.caption}>{count}</figcaption> : null;
};

export default withStyles(styles)(AfitdBadgeCount);
